import React, { memo } from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import ModalityInfo from '../../../views/ModalityInfo';


const EquipmentTypeComponent = memo(({ extraParams }) => {
	return (
		<Grid container size={12}>
			<Grid size={12} sx={{ margin: '10px 0px' }}>
				<Card>
					<CardContent>
						<Grid container size={'grow'}>
							<Grid size={12}>
								<ModalityInfo extraParams={extraParams} />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	)
})

export default EquipmentTypeComponent;